import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _asyncToGenerator from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
var _excluded = ["classId"];
import _regeneratorRuntime from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Result } from '@digibricks/core';
import { ErrorResultHandler } from '@lib/domain-common';
import { AxiosApi } from '@digibricks/plugin-axios';
import { ParticipatedAssignmentResponder } from '../../../core';
export var PARTICIPATED_ASSIGNMENT_API = 'PARTICIPATED_ASSIGNMENT_API';
export var ParticipatedAssignmentApi = /*#__PURE__*/function (_AxiosApi) {
  _inherits(ParticipatedAssignmentApi, _AxiosApi);

  var _super = _createSuper(ParticipatedAssignmentApi);

  function ParticipatedAssignmentApi(axiosInstance) {
    var _this;

    _classCallCheck(this, ParticipatedAssignmentApi);

    _this = _super.call(this, 'assignments', axiosInstance);
    _this.axiosInstance = axiosInstance;
    return _this;
  }

  _createClass(ParticipatedAssignmentApi, [{
    key: "getParticipatedAssignmentPage",
    value: function () {
      var _getParticipatedAssignmentPage = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(query) {
        var classId, params, response, body, page;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                classId = query.classId, params = _objectWithoutProperties(query, _excluded);
                _context.next = 4;
                return this.axios.get(classId ? "".concat(this.url, "/classes/").concat(encodeURIComponent(classId)) : "".concat(this.url, "/participated"), {
                  headers: {
                    Authorization: "Bearer ".concat(localStorage.getItem('access_token'))
                  },
                  paramsSerializer: function paramsSerializer(params) {
                    var searchParams = new URLSearchParams();
                    Object.entries(params).forEach(function (_ref) {
                      var _ref2 = _slicedToArray(_ref, 2),
                          key = _ref2[0],
                          value = _ref2[1];

                      if (value == null) return;
                      var values = Array.isArray(value) ? value : [value];
                      values.forEach(function (item) {
                        return searchParams.append(key, String(item));
                      });
                    });
                    return searchParams.toString();
                  },
                  params: {
                    search: params.search,
                    statuses: params.statuses,
                    types: params.types,
                    overdue: params.overdue,
                    limit: params.limit,
                    nextToken: params.nextToken
                  }
                });

              case 4:
                response = _context.sent;
                body = response.data;

                if (!(!body.data || Array.isArray(body.data))) {
                  _context.next = 8;
                  break;
                }

                return _context.abrupt("return", Result.fail(body.message || 'Invalid paginated assignment response'));

              case 8:
                page = body.data;
                return _context.abrupt("return", Result.ok(_objectSpread(_objectSpread({}, page), {}, {
                  items: page.items.map(function (item) {
                    return ParticipatedAssignmentResponder.fromJson(item).getValue();
                  }),
                  summary: _objectSpread(_objectSpread({}, page.summary), {}, {
                    nextExam: page.summary.nextExam ? ParticipatedAssignmentResponder.fromJson(page.summary.nextExam).getValue() : null,
                    nextAssignment: page.summary.nextAssignment ? ParticipatedAssignmentResponder.fromJson(page.summary.nextAssignment).getValue() : null
                  })
                })));

              case 12:
                _context.prev = 12;
                _context.t0 = _context["catch"](0);
                return _context.abrupt("return", ErrorResultHandler(_context.t0));

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 12]]);
      }));

      function getParticipatedAssignmentPage(_x) {
        return _getParticipatedAssignmentPage.apply(this, arguments);
      }

      return getParticipatedAssignmentPage;
    }()
  }, {
    key: "getParticipatedAssignment",
    value: function () {
      var _getParticipatedAssignment = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(queryParams) {
        var params, url, jsonResponse, parsedResponseBody, responses;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                params = queryParams;
                url = "".concat(this.url, "/participated");
                _context2.next = 5;
                return this.axios.get(url, {
                  headers: {
                    Authorization: "Bearer ".concat(localStorage.getItem('access_token'))
                  },
                  params: params
                });

              case 5:
                jsonResponse = _context2.sent;
                parsedResponseBody = jsonResponse.data;

                if (parsedResponseBody.data) {
                  _context2.next = 9;
                  break;
                }

                return _context2.abrupt("return", Result.fail(parsedResponseBody.message));

              case 9:
                responses = parsedResponseBody.data.map(function (data) {
                  return ParticipatedAssignmentResponder.fromJson(data).getValue();
                });
                return _context2.abrupt("return", Result.ok(responses));

              case 13:
                _context2.prev = 13;
                _context2.t0 = _context2["catch"](0);
                return _context2.abrupt("return", ErrorResultHandler(_context2.t0));

              case 16:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 13]]);
      }));

      function getParticipatedAssignment(_x2) {
        return _getParticipatedAssignment.apply(this, arguments);
      }

      return getParticipatedAssignment;
    }()
  }]);

  return ParticipatedAssignmentApi;
}(AxiosApi);